package com.partejar.app.feature.profile.data.remote

import kotlinx.serialization.Serializable

@Serializable
data class UserProfileDto(
    val id: Long,
    val nome: String,
    val nomeCompleto: String? = null,
    val cpf: String? = null,
    val email: String
)

@Serializable
data class UpdateUserProfileDto(val nome: String, val cpf: String? = null)
@Serializable data class UserProfessionalRegistrationDto(val id: Long, val categoriaProfissional: String, val conselho: String, val numero: String, val uf: String, val ativo: Boolean)
@Serializable data class UserProfessionalRegistrationRequestDto(val categoriaProfissional: String, val conselho: String, val numero: String, val uf: String)
